export function detectOS(userAgent: string): string {
  if (/Windows NT 10/.test(userAgent)) return 'Windows 10/11';
  if (/Windows NT 6\.3/.test(userAgent)) return 'Windows 8.1';
  if (/Windows/.test(userAgent)) return 'Windows';
  if (/iPhone|iPad/.test(userAgent)) return 'iOS';
  if (/Android/.test(userAgent)) return 'Android';
  if (/Mac OS X/.test(userAgent)) {
    const match = new RegExp(/Mac OS X ([\d_]+)/).exec(userAgent);
    return `macOS ${(match?.[1] ?? '').replaceAll('_', '.')}`.trim();
  }
  if (/Linux/.test(userAgent)) return 'Linux';
  return '[Unknown OS]';
}
